import { FacetValueTags } from "./FacetValueTags";
import { FilterAccordion } from "./FilterAccordion";
import { FacetGroupSelect } from "./FacetGroupSelect";
import { FilterAccordions } from "./FilterAccordions";
import { FilterTitles } from "./FilterTitles";
import { Filter } from "./Filter";
import { ShadowFacetTracking } from "./ShadowFacetTracking";
import { isActive } from "../toggle/Toggle";
import { OcFilterAccordion } from "./OcFilterAccordion";
import { OcFilterAccordions } from "./OcFilterAccordions";

export function registerFilterStuff() {
  if (isActive("HEUREKA_1975_OC_COMPONENTS_MIGRATION")) {
    OcFilterAccordion.register();
  } else {
    FilterAccordion.register();
  }
  FacetGroupSelect.register();
  FacetValueTags.register();
  if (isActive("HEUREKA_1975_OC_COMPONENTS_MIGRATION")) {
    OcFilterAccordions.register();
  } else {
    FilterAccordions.register();
  }
  FilterTitles.register();
  Filter.register();
  ShadowFacetTracking.register();
}
